import React from 'react';

const AdminBlog: React.FC = () => {
  return (
    <div className="admin-page">
      <h2>Blog Management</h2>
      <p>This page would contain tools to create and manage blog posts.</p>
    </div>
  );
};

export default AdminBlog;